module.exports = "/assets/data/9f310d9fb3008465b105171531e2824c-RM17.data.json";